import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Search, GitBranch, Users, Shield } from "lucide-react";

interface PipelineFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  statistics: {
    totalPipelines: number;
    totalPermissions: number;
    totalRoles: number;
  };
}

export function PipelineFilters({
  searchQuery,
  onSearchChange,
  statistics,
}: PipelineFiltersProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center space-x-2">
              <GitBranch className="h-8 w-8 text-blue-600" />
              <div>
                <p className="text-2xl font-bold text-slate-900">
                  {statistics.totalPipelines}
                </p>
                <p className="text-sm text-slate-600">Total Pipelines</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center space-x-2">
              <Shield className="h-8 w-8 text-green-600" />
              <div>
                <p className="text-2xl font-bold text-slate-900">
                  {statistics.totalPermissions}
                </p>
                <p className="text-sm text-slate-600">Permisos Asignados</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="pt-6">
            <div className="flex items-center space-x-2">
              <Users className="h-8 w-8 text-purple-600" />
              <div>
                <p className="text-2xl font-bold text-slate-900">
                  {statistics.totalRoles}
                </p>
                <p className="text-sm text-slate-600">Roles Configurados</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardContent className="pt-6">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
            <Input
              placeholder="Buscar pipelines por nombre o descripción..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-10"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
